import { openBlock, createElementBlock, normalizeClass, renderSlot, pushScopeId, popScopeId, createElementVNode } from "vue";
/* empty css                 */
import _export_sfc from "../uikit._virtual/_plugin-vue_export-helper.es.js";
const _withScopeId = (n) => (pushScopeId("data-v-0be9e342"), n = n(), popScopeId(), n);
const _hoisted_1 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("div", { class: "skeleton-row" }, null, -1));
const _hoisted_2 = [
  _hoisted_1
];
const _sfc_main = {
  __name: "Skeleton",
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    active: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: "text",
      validator: (value) => ["text", "input"].includes(value)
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return __props.loading ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(["skeleton", { "skeleton-active": __props.active, "skeleton-input": __props.type === "input" }])
      }, _hoisted_2, 2)) : renderSlot(_ctx.$slots, "default", { key: 1 }, void 0, true);
    };
  }
};
const UikitSkeleton = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-0be9e342"]]);
export {
  UikitSkeleton as default
};
//# sourceMappingURL=Skeleton.vue.es.js.map
